import { useState, type FormEvent } from "react";
import { useNavigate } from "react-router";
import { Button, Input, FormField, Heading, Text } from "@/components/ds";
import { getStoredGclid } from "@/analytics/gclid";
import { useSignupWizard } from "./SignupWizardProvider";
import styles from "./SignupEmailStep.module.css";

export function SignupEmailStep() {
  const navigate = useNavigate();
  const { email, setEmail } = useSignupWizard();
  const [localEmail, setLocalEmail] = useState(email);
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(event: FormEvent) {
    event.preventDefault();
    const trimmed = localEmail.trim();

    if (!trimmed || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed)) {
      setError("Please enter a valid email address");
      return;
    }

    setEmail(trimmed);
    setSubmitting(true);
    try {
      const gclid = getStoredGclid();
      await fetch("/api/lead-capture", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: trimmed, gclid }),
      });
    } finally {
      navigate("/signup/password");
    }
  }

  return (
    <form onSubmit={handleSubmit} className={styles.form}>
      <Heading level={1} size="h3">Create your account</Heading>
      <Text size="sm" color="muted">
        Start your 14-day free trial. No credit card needed.
      </Text>

      <FormField label="Email" htmlFor="signup-email" error={error}>
        <Input
          type="email"
          name="email"
          id="signup-email"
          value={localEmail}
          onChange={(e) => {
            setLocalEmail(e.target.value);
            setError("");
          }}
          error={!!error}
          required
        />
      </FormField>

      <Button type="submit" fullWidth disabled={submitting}>
        {submitting ? "Continuing…" : "Continue"}
      </Button>

      <p className={styles.footer}>
        Already have an account?{" "}
        <a href="/login" className={styles.link}>
          Log in
        </a>
      </p>
    </form>
  );
}
